import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchNotifications,
  markAllAsReadNotifications,
  markSingleNotificationAsRead,
} from '../../services/notificationService';
import { queryKeys } from './queryKeys';

export const useNotificationsQuery = (userId: string) =>
  useQuery({
    queryKey: queryKeys.notifications.byUser(userId),
    queryFn: () => fetchNotifications(userId),
    enabled: !!userId,
    staleTime: 0,
  });

export const useMarkAllNotificationsRead = (userId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => markAllAsReadNotifications(userId),
    onSuccess: () => {
      queryClient.setQueryData(
        queryKeys.notifications.byUser(userId),
        (old: any[]) => (old ? old.map((n) => ({ ...n, isRead: true })) : []),
      );
    },
  });
};

export const useMarkSingleNotificationRead = (userId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (notificationId: string) =>
      markSingleNotificationAsRead(notificationId),
    onSuccess: (_data, notificationId) => {
      queryClient.setQueryData(
        queryKeys.notifications.byUser(userId),
        (old: any[]) =>
          old
            ? old.map((n) =>
                n._id === notificationId ? { ...n, isRead: true } : n,
              )
            : [],
      );
    },
  });
};
